import {
  defineSaleProgress,
  hasAddress,
  isSaleCreated,
  isSaleStarted,
  type ProgressSaleData,
  type SaleStatus,
} from '../saleProgress'
import type { ScriptSteps } from '../scripts/blocks/stages'

interface SantianeData extends ProgressSaleData {
  scriptSteps?: ScriptSteps | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export const isSantianePlatformOpened = (data: SantianeData) => !!data.scriptSteps?.extLink

export default defineSaleProgress<SantianeData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'link_opened', label: `${TIMELINE}link_opened`, done: isSantianePlatformOpened },
    { key: 'created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps): SaleStatus => {
    if (steps[steps.length - 1]?.state === 'done') return 'signed'
    if (isSaleStarted(data) || steps.some(step => step.state === 'done')) return 'progress'

    return 'new'
  },
})
